import { render, staticRenderFns } from "./UpdateInvoice.vue?vue&type=template&id=3224b076&"
import script from "./UpdateInvoice.vue?vue&type=script&lang=js&"
export * from "./UpdateInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports